var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M24.587 4.08H7.413A3.343 3.343 0 0 0 4.08 7.413v17.174a3.343 3.343 0 0 0 3.333 3.333h17.174a3.334 3.334 0 0 0 3.333-3.333V7.413a3.333 3.333 0 0 0-3.333-3.333m2 20.507a2.014 2.014 0 0 1-2 2H7.413a2.015 2.015 0 0 1-2-2V7.413a2.015 2.015 0 0 1 2-2h17.174a2.015 2.015 0 0 1 2 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M8.501 14.33a1.333 1.333 0 1 1 2.667 0v8.667a1.333 1.333 0 1 1-2.667 0zM9.834 10.325a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M23.494 17.827V23a1.333 1.333 0 0 1-2.667 0v-5.173a2.154 2.154 0 1 0-4.307 0V23a1.333 1.333 0 0 1-2.666 0v-8.667A1.355 1.355 0 0 1 15.187 13a1.25 1.25 0 0 1 1.12.627 4.812 4.812 0 0 1 7.187 4.2"
  })));
};
export default SvgLinkedin;